import React from 'react';
import PropTypes from 'prop-types';
import GlistColumn from "../../../manager/columns-manager/column";

type Props = {
    className?  : string,
    column      : GlistColumn,
    isFirst :boolean,
    isLast: boolean,
}

export default function GlistHeaderCellTitle(props:Props) {

    const classes = Classes("cell-title", props.column.alignment, props.className, props.column.headerLabelClassName, {
        'is-first': props.isFirst,
        'is-last': props.isLast
    });

    const style : style = {width:props.column.width}

    return <div className={classes} style={style} >
        <div className="ui5-title-small m-b-10">{props.column.label}</div>
    </div>
}